export default __webpack_public_path__ + "static/media/snake.cab9f420.png";